export const env = {
  AGENT_BASE_URL: import.meta.env.VITE_AGENT_BASE_URL,
  COMMAND_BAR_BASE_URL: import.meta.env.VITE_COMMAND_BAR_BASE_URL,
  COMMAND_BAR_TAG_NAME: import.meta.env.VITE_COMMAND_BAR_TAG_NAME,
};
